module.exports = "https://static.energy5.com/_next/static/images/step1Image-8747399b9870ad69e28fa5df781b48e2.jpg";